module.exports = __webpack_public_path__ + "img/Gruppenführer_TW.93fd4436.svg";